import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from '@/lang/en.json'
import fr from '@/lang/fr-CA.json'

Vue.use(VueI18n)

const messages = {
  en,
  'fr-ca': fr
}

const i18n = new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages,
  silentTranslationWarnings: process.env.NODE_ENV === 'production'
})

export default i18n
